export function assemblyBounds(i) {
  var bounds = {
    32: [
      -119.80942747676612, 34.78865450296283, -117.6165168579814,
      36.74481831200444,
    ],
    34: [
      -118.89463531894332, 34.03410819847493, -114.94815565600447,
      35.809236408082796,
    ],
    38: [
      -119.63630086532062, 33.163492154732076, -118.67059448963927,
      34.901170232526766,
    ],
    39: [
      -118.16613428103196, 34.397086638109585, -117.27913895574254,
      34.82330152977331,
    ],
    40: [
      -118.74197251518498, 34.208401664331845, -118.18804183943908,
      34.58793319540977,
    ],
    41: [
      -118.23890413169637, 34.06366032656113, -117.35501998510097,
      34.50697772728828,
    ],
    42: [
      -119.12013950701144, 33.946904222150046, -118.4192508009384,
      34.37345724265557,
    ],
    43: [
      -118.50834248570456, 34.17212219611657, -118.34300824387644,
      34.33730661954947,
    ],
    44: [
      -118.47574622146074, 34.1190375273752, -118.1815833740041,
      34.293259047672386,
    ],
    46: [
      -118.715389620243, 34.122850336381426, -118.42670356756281,
      34.242697482520036,
    ],
    48: [
      -118.01692631499068, 34.001730736070684, -117.7938408696282,
      34.17966354292875,
    ],
    49: [
      -118.17799416690278, 34.02699258080738, -117.99219035754432,
      34.17945348994293,
    ],
    51: [
      -118.56311401325839, 33.966884083892815, -118.26539133658692,
      34.16143811006437,
    ],
    52: [
      -118.30929772145215, 34.008045173413734, -118.12672810125456,
      34.15586663530208,
    ],
    53: [
      -117.83586391116614, 33.95335888077291, -117.5240905669361,
      34.1126009888673,
    ],
    54: [
      -118.32670471340612, 33.97096731521841, -118.07300336657356,
      34.09087218538161,
    ],
    55: [
      -118.45599258689714, 33.97204533358852, -118.30016523154312,
      34.07671205719373,
    ],
    56: [
      -118.122811192585, 33.92803373025454, -117.76704596748074,
      34.072264486065386,
    ],
    57: [
      -118.3177616384752, 33.92731565243926, -118.22860190580468,
      34.0528133431208,
    ],
    59: [
      -117.95773046070627, 33.735240001275336, -117.60726997229959,
      34.02350797623824,
    ],
    61: [
      -118.53766200292834, 33.872853100323006, -118.279670215892,
      34.00998966084851,
    ],
    62: [
      -118.23902050875719, 33.82004626742356, -118.05892055848554,
      33.9966671733963,
    ],
    64: [
      -118.20623975849239, 33.873321557925316, -117.91892047371647,
      33.99954456366613,
    ],
    65: [
      -118.35200960018341, 33.65954706646204, -118.14659459440045,
      33.95426723504944,
    ],
    66: [
      -118.49887084119312, 33.66664908305732, -118.27968752124185,
      33.93149416330665,
    ],
    67: [
      -118.10856450221603, 33.7888548121103, -117.87897027383899,
      33.906461740967146,
    ],
    69: [
      -118.67854893805048, 32.75004257029633, -118.06317058134275,
      33.860261726291085,
    ],
    70: [
      -118.09705676245486, 33.6855079416569, -117.88916916520598,
      33.81968054900419,
    ],
    72: [
      -118.14780697321173, 33.41897566207966, -117.62055986901986,
      33.77480871041892,
    ],
  };
  return bounds[i];
}
